import * as React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { selectIsTimesheetImportEnabled } from 'services/organizationConfig/selectors';

export interface Props {
    children: React.ReactElement;
}

export default function TimesheetImportEnabledGate(
    props: Props
): React.ReactElement | null {
    const { children } = props;

    const isTimesheetImportEnabled = useSelector(
        selectIsTimesheetImportEnabled
    );
    if (!isTimesheetImportEnabled) return null;
    return children;
}
